export default {
  FETCH_PROJECT_STATS_REQUEST: 'FETCH_PROJECT_STATS_REQUEST',
  FETCH_PROJECT_STATS_SUCCESS: 'FETCH_PROJECT_STATS_SUCCESS',
  FETCH_PROJECT_STATS_FAILURE: 'FETCH_PROJECT_STATS_FAILURE'
}
